import * as StyledComponents from '../StyledComponents';
import { INPUT_SIZES, IconAdd, Divider } from 'cdk-radial';
import { useUnifyAdminStore } from '../../AdminStore';
import { SIDE_SHEET_TITLE_NAMES } from '../../Constants';
import { Switch } from 'cdk-radial';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function FeatureReleaseNotificationListHeader(
  props: Readonly<{ gridRef: any }>
): JSX.Element {
  const searchValue = useUnifyAdminStore((state) => state.releaseSearchValue);
  const archiveSwitch = useUnifyAdminStore((state) => state.releaseArchiveSwitch);
  const { t } = useTranslation();

  const releasePermission = useUnifyAdminStore(
    (state) => state.permissions
  );
  const setReleaseSearchValue = useUnifyAdminStore(
    (state) => state.setReleaseSearchValue
  );
  const setArchiveSwitch = useUnifyAdminStore(
    (state) => state.setReleaseArchiveSwitch
  );
  const setSideSheetTitleName = useUnifyAdminStore(
    (state) => state.setSideSheetTitleName
  );
  const setReleaseSheetCollapse = useUnifyAdminStore(
    (state) => state.setReleaseSideSheetCollapse
  );
  const resetReleaseSideSheetState = useUnifyAdminStore(
    (state) => state.resetReleaseSideSheetState
  );

  useEffect(() => {
    setReleaseSheetCollapse(true);
  }, [archiveSwitch, setReleaseSheetCollapse]);

  const onExportDownloadButton = () => {
    props?.gridRef?.current?.api?.exportDataAsExcel({
      processRowGroupCallback: (params: any) => {
        return params.node.key;
      },
    });
  };

  const handleNewRelease = (): void => {
    setSideSheetTitleName(SIDE_SHEET_TITLE_NAMES.PRODUCT_ALERT);
    resetReleaseSideSheetState();
    setReleaseSheetCollapse(false);
  };

  return (
    <>
      <Divider />
      <StyledComponents.StyledHeaderContainer>

        <div style={{display:'flex'}}>
        <StyledComponents.StyledHeading
          headingType="subtitle-2"
          data-testid="outage-notification-list"
        >
          {t('featureRelease.title')}
        </StyledComponents.StyledHeading>
        <StyledComponents.StyledSwitch>
          <Switch
                dataTestId="switch"
                id="archive"
                label={t('featureRelease.showArchived')}
                labelPosition="before"
                name="archive"
                onChange={(event: any) => setArchiveSwitch(event.target.checked)}
                size="standard"
                checked={archiveSwitch}
              />
          </StyledComponents.StyledSwitch>
        </div>
        <StyledComponents.StyledHeading
          headingType="subtitle-2"
          padding="0px 15px"
        >
          <StyledComponents.StyledIconFileDownload
            onClick={() => onExportDownloadButton()}
            data-testid="export-search-result-icon"
          />
        </StyledComponents.StyledHeading>
      </StyledComponents.StyledHeaderContainer>

      <StyledComponents.StyledSearchBoxContainer>
        <StyledComponents.StyledSearchBox
          dataTestId="outage-search-input"
          className="customize-search-input"
          clearButtonLabel="clearButtonLabel"
          id="outage-grid-search-input-expanded"
          isAlwaysExpanded
          name="outage-grid-search-input-expanded"
          onChange={(searchValue: string) => setReleaseSearchValue(searchValue)}
          placeholder={t('featureRelease.search')}
          size={INPUT_SIZES.STANDARD}
          value={searchValue}
        />
        {releasePermission?.hasReleaseUpdatePermissions && !archiveSwitch && (
            <StyledComponents.StyledButtonWithIcon
              onClick={() => handleNewRelease()}
              variant="secondary"
              text={t('featureRelease.createButton')}
              icon={<IconAdd />}
            />
          )}
      </StyledComponents.StyledSearchBoxContainer>

    </>
  );
}
